const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Build full media URL from relative paths.
 * Handles: /api/files/..., /api/uploads/..., data:..., and external URLs
 */
export const getMediaUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('data:')) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/api/')) return `${BACKEND_URL}${url}`;
  if (url.startsWith('/uploads/')) return `${BACKEND_URL}/api${url}`;
  return url;
};
